var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfferArrowDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.2175 1.588C11.4453 1.3602 11.4439 0.9894 11.2161 0.761593C10.9882 0.533787 10.6174 0.532333 10.3896 0.760138L5.99859 5.15119L1.60753 0.760138C1.37973 0.532333 1.00893 0.533787 0.781121 0.761593C0.553315 0.9894 0.551861 1.3602 0.779666 1.588L5.58611 6.39444C5.81391 6.62225 6.18326 6.62225 6.41106 6.39444L11.2175 1.588Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferArrowDown);
export default __webpack_public_path__ + "static/media/OfferArrowDown.0881fae399ba3e29a7ee5c09a59b4353.svg";
export { ForwardRef as ReactComponent };